import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=d63900ea&scoped=true&"
import script from "./ProductInformation.vue?vue&type=script&lang=js&"
export * from "./ProductInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductInformation.vue?vue&type=style&index=0&id=d63900ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63900ea",
  null
  
)

export default component.exports